export default __webpack_public_path__ + "static/media/01n.caa4c68a.png";